import { default as React } from "react";
import ReactPaginate from 'react-paginate';
import { withTranslation, WithTranslation } from "react-i18next";

interface OwnProps {
    currentPage: number;
    pageCount: number;
    realCount: number;
    onPageClick: (n: number) => void;
}
const scrollPosition=document.getElementsByClassName("xx");
const Pagination = ({ pageCount, currentPage, realCount, onPageClick, t }: OwnProps & WithTranslation) =>
    (pageCount > 0 || realCount > pageCount) ?
        <nav aria-label="Page navigation example" style={{ display: "flex" }}>
            <ReactPaginate
                containerClassName="pagination p-0 m-2 ml-3"
                pageCount={pageCount}
                forcePage={currentPage}
                onPageChange={(n) => {onPageClick(n.selected);scrollPosition[0].scrollTo(0,0)}}
                breakClassName="page-item"
                pageClassName="page-item"
                previousClassName="page-item"
                nextClassName="page-item"
                pageLinkClassName="page-link"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                breakLabel={<a className="page-link">...</a>}
                activeClassName="active"
                disabledClassName="disabled"
                nextLabel={t("common:next")}
                previousLabel={t("common:previous")}
                marginPagesDisplayed={2}
                pageRangeDisplayed={8}
            />
            {(realCount > pageCount) && (pageCount == currentPage + 1) && <span style={{ marginTop: "15px" }}></span>}
        </nav>
        : null;

export default withTranslation()(Pagination);